import React, { useEffect } from 'react';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import sizes from 'theme/sizes';
import indexPriority from 'theme/z-index';
import { X } from 'lucide-react';
import { setRealVh } from 'helpers/generic-css';

export default function HommeCollapse({
    children,
    onClose,
    visible = false,
}) {
    useEffect(() => {
        if (visible) {
            document.body.classList.add('no-scroll')
        } else {
            document.body.classList.remove('no-scroll')
        }
    }, [visible])

    useEffect(() => {
        setRealVh();
        window.addEventListener('resize', setRealVh);
        return () => window.removeEventListener('resize', setRealVh);
    })

    return (
        <Container visible={visible} onClick={() => onClose()}>
            <CollapseContainer
                visible={visible}
                onClick={(e) => e.stopPropagation()}
            >
                <ContentButtons>
                    {
                        visible && (
                            <CloseButtonContainer>
                                <X size='25px' color={colors.night} onClick={() => onClose()} />
                            </CloseButtonContainer>
                        )
                    }
                </ContentButtons>
                {children}
            </CollapseContainer>
        </Container>
    )
};

const Container = styled.div`
    height: calc(var(--vh, 1vh) * 100);
    width: 0;
    display: flex;
    align-items: flex-end;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1000;
    transition: all .35s ease-in-out;
    

    ${({ visible }) => visible && `
        width: 100%;
        z-index: 99999999999999999999999;

        &:after {
            content: '';
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            background: ${colors.nightDark};
            opacity: .85;
            z-index: -200;
        }
    `}
`;

const CollapseContainer = styled.div`
    position: relative;
    background: ${colors.neutralLight};
    box-shadow: ${sizes.none} ${sizes.none} ${sizes.tiny} ${colors.nightLight};
    z-index: ${indexPriority.high};
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 10px 20px 10px;
    height: 100%;
    width: 0;
    opacity: 0;
    visibility: hidden;
    transition: all .35s ease-in-out;

    /**
        Prevents iOS rubber-band scroll.
    */
    max-height: calc(var(--vh, 1vh) * 100);
    -webkit-overflow-scrolling: touch;
    
    ${({ visible }) => visible && `
        width: 100%;
        opacity: 1;
        visibility: visible;
        
        @media screen and (min-width: ${breakpoints.md}) {
            padding: 0 20px 50px 20px;
            width: 75%;
            border-radius:  ${sizes.none} ${sizes.small} ${sizes.small} ${sizes.none} ;
        }
    `};

    ${({ widthOnDesktop }) => widthOnDesktop && `
        @media screen and (min-width: ${breakpoints.lg}) {
            width: ${widthOnDesktop} !important;
        }
    `};
`

const CloseButtonContainer = styled.div`
    width: 34px;
    position: sticky;
    top: 0;
    left: 0;
    display:flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 10px 0;
    background: ${colors.neutralLight};
    z-index: ${indexPriority.high};
    cursor: pointer;
`;

const ContentButtons = styled.div`
    padding-top: 10px;
    width: 100%;
    height: 40px;
    // background: green;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;
